function CampaignWizardSummaryController(
    $scope,
    $injector,
    $timeout,
    $uibModal,
    $state,
    LocalisationService,
    CampaignsService,
    ErrorService,
    CampaignWizardService,
    PermissionService
) {
    var self = this;

    self.campaign = null;

    self.initialise = function() {
        if(!CampaignWizardService.Campaign) {
            $scope.goToPreviousTab();
            return;
        }

        CampaignWizardService.CheckUserAccessToCampaignManagement();

        $scope.campaign = CampaignWizardService.Campaign;
        $scope.cannotActivateCampaignMessage = "";
        self.userContext = PermissionService.userContext;
        self.loadData();
    };

    self.loadData = function() {
        if($scope.campaign.TemplateActions) {
            CampaignWizardService.InitialiseCommunications(
                $scope.campaign.TemplateActions.Communications,
                LocalisationService
            );
            CampaignWizardService.CalculateCommunicationsCosts(
                $scope.campaign.TemplateActions.Communications,
                $scope.campaign);
        }
    };

    $scope.campaignStartDate = function() {
        if(!$scope.campaign) {
            return "";
        }

        return LocalisationService.combineDateTimeAndFormat(
            $scope.campaign.PublishStartDate,
            $scope.campaign.PublishStartTime,
            LocalisationService.Configuration.DateTimeFormat
        );
    };

    $scope.voucherExpiryOverride = function () {
        const hasVoucherOverride = $scope.hasVoucherOverride($scope.campaign);

        if (!hasVoucherOverride) {
            return "";
        }

        return $scope.campaign.TemplateActions.Vouchers[0].ExpiryDaysOverride;
    };

    $scope.voucherExpiryDate = function () {
        const hasVouchers = $scope.hasVouchers($scope.campaign);
        const endTime = "23:59:59";

        if (!hasVouchers) {
            return "";
        }

        const expiryDaysOverride = $scope.campaign.TemplateActions.Vouchers[0].ExpiryDaysOverride;

        if (!expiryDaysOverride || expiryDaysOverride <= 0) {
            return LocalisationService.combineDateTimeAndFormat(
                $scope.campaign.PublishEndDate,
                endTime,
                LocalisationService.Configuration.DateTimeFormat
            );
        }

        let expiryDate = new Date($scope.campaign.PublishStartDate);
        expiryDate.setDate(expiryDate.getDate() + expiryDaysOverride);

        return LocalisationService.combineDateTimeAndFormat(
            expiryDate,
            endTime,
            LocalisationService.Configuration.DateTimeFormat
        );
    };

    $scope.hasVoucherOverride = CampaignWizardService.HasVoucherOverride;
    $scope.hasVouchers = CampaignWizardService.HasVouchers;
    $scope.hasCommunications = CampaignWizardService.HasCommunications;

    $scope.hasTemplateActions = function() {
        return $scope.campaign
        && $scope.campaign.TemplateActions;
    };

    $scope.communications = function() {
        if(!$scope.hasCommunications($scope.campaign)) {
            return [];
        }

        return $scope.campaign.TemplateActions.Communications;
    };

    $scope.getTypeTags = function(communication) {
        var tags = CampaignWizardService.GetCommunicationTypeTags(communication);

        if(tags.length === 0) {
            return "";
        }

        return "(" + tags.join(', ') + ")";
    };

    $scope.formatDateTime = function(
        date,
        time) {
        return LocalisationService.combineDateTimeAndFormat(
            date,
            time,
            LocalisationService.Configuration.DateTimeFormat
        );
    };

    $scope.campaignEndDate = function() {
        if(!$scope.campaign) {
            return "";
        }

        return LocalisationService.combineDateTimeAndFormat(
            $scope.campaign.PublishEndDate,
            $scope.campaign.PublishEndTime,
            LocalisationService.Configuration.DateTimeFormat
        );
    };

    $scope.publishDateTime = function() {
        if(!$scope.campaign) {
            return "";
        }

        return LocalisationService.combineDateTimeAndFormat(
            $scope.campaign.PublishDate,
            $scope.campaign.PublishTime,
            LocalisationService.Configuration.DateTimeFormat
        );
    };

    /**
     * Publishes the campaign and then navigates to the current active campaigns
     */
    $scope.publishCampaign = function () {
        if ($scope.busyProcessingCampaign) {
            return;
        }
        $scope.busyProcessingCampaign = true;
        let publishStartDateTime = LocalisationService.combineDateTime($scope.campaign.PublishStartDate, LocalisationService.formatDateTime($scope.campaign.PublishStartTime, "HH:mm"));
        let publishEndDateTime = LocalisationService.combineDateTime($scope.campaign.PublishEndDate, LocalisationService.formatDateTime($scope.campaign.PublishEndTime, "HH:mm"));

        // Set the launch date to the earliest date when comparing start date and communication dates
        let launchDate = publishStartDateTime;

        const noPublishDates = $scope.campaign.TemplateActions.Vouchers.length === 0 && $scope.campaign.TemplateActions.Menuscripts.length === 0;

        // If no start/end dates are selected in the UI, we want to discard those
        // dates when checking what the earliest date is
        if (noPublishDates){
            launchDate = null
        }

        let lastCommsDateTime = null;

        const communications = [];
        _.each($scope.campaign.TemplateActions.Communications, function (comms) {
            comms.ScheduledDate = LocalisationService.combineDateTime(comms.PublishDate, LocalisationService.formatDateTime(comms.PublishTime, "HH:mm"));

            if (!launchDate){
                launchDate = comms.ScheduledDate;
            }

            if (!lastCommsDateTime){
                lastCommsDateTime = comms.ScheduledDate;
            }

            launchDate = comms.ScheduledDate < launchDate ? comms.ScheduledDate : launchDate;
            lastCommsDateTime = lastCommsDateTime > comms.ScheduledDate ? lastCommsDateTime : comms.ScheduledDate;

            // Set the communications collection that is passed to the API
            const excludedCommunicationTypes = [];
            if (comms.SMSDisabled) {
                excludedCommunicationTypes.push(Dashboard.CommunicationMessageType.SMS);
            }
            const communication = {
                CampaignCommunicationTemplateId: comms.Id,
                Variables: null,
                ScheduledDate: LocalisationService.formatDateTimeForAPIRequest(comms.ScheduledDate),
                ExcludedCommunicationTypes: excludedCommunicationTypes
            };
            communications.push(communication);
        });

        // If there are no vouchers or menuscripts (which means no publish start/end dates can be set on the UI
        // then set the start date to the earliest comms date and the end date to the latest comms date
        if (noPublishDates){
            publishStartDateTime = launchDate;
            publishEndDateTime = lastCommsDateTime;
        }

        // Set the vouchers collection that is passed to the API
        const vouchers = [];
        _.each($scope.campaign.TemplateActions.Vouchers, function (action) {
            const voucher = {
                CampaignVoucherTemplateId: action.Id,
                StartDate: LocalisationService.formatDateTimeForAPIRequest(publishStartDateTime),
                EndDate: LocalisationService.formatDateTimeForAPIRequest(publishEndDateTime),
                ExpiryDaysOverride: action.ExpiryDaysOverride
            };
            vouchers.push(voucher);
        });

        // Set the menu scripts collection that is passed to the API
        const menuScripts = [];
        _.each($scope.campaign.TemplateActions.Menuscripts, function (action) {
            var menuScript = {
                CampaignMenuscriptTemplateId: action.Id,
                StartDate: LocalisationService.formatDateTimeForAPIRequest(publishStartDateTime),
                EndDate: LocalisationService.formatDateTimeForAPIRequest(publishEndDateTime)
            };
            menuScripts.push(menuScript);
        });

        const publishRequest = {
            CampaignTemplateId: $scope.campaign.Id,
            Version: $scope.campaign.Version,
            BrandId: self.userContext.BrandId,
            StoreId: self.userContext.StoreId,
            MaxCustomers: $scope.campaign.SelectedCustomerCount,
            LaunchDate: LocalisationService.formatDateTimeForAPIRequest(launchDate),
            StartDate: LocalisationService.formatDateTimeForAPIRequest(publishStartDateTime),
            EndDate: LocalisationService.formatDateTimeForAPIRequest(publishEndDateTime),
            Vouchers: vouchers,
            Menuscripts: menuScripts,
            Communication: communications,
            CampaignTargetSourceId: $scope.campaign.selectedTargetSource
        };

        $scope.$root.isLoading = true;
        CampaignsService.publishCampaign(publishRequest).then(
            function (result) {
                // Show the campaign successfully published modal
                self.showCampaignPublishedSuccessModal(publishRequest.LaunchDate);
            },
            function failure (result) {
                ErrorService.showError('An error occurred when attempting to publish this campaign', result);
            }
        ).finally(
            function () {
                $scope.$root.isLoading = false;
                $scope.busyProcessingCampaign = false;
            }
        );
    };

    $scope.goToPreviousTab = function() {
        CampaignWizardService.Campaign = $scope.campaign;
        $state.go(
            Dashboard.helpers.stateHelper.getParentState($state.current.name) + '.customise',
            {
                storeId: $state.params.storeId,
                brandId: $state.params.brandId,
                CampaignTemplateId: $state.params.CampaignTemplateId
            })
    };

    $scope.canActivateCampaign = function() {
        $scope.cannotActivateCampaignMessage = "";
        if(!$scope.campaign) {
            return false;
        }

        if (!$scope.userHasPermissionToActivateCampaign()) {
            $scope.cannotActivateCampaignMessage = "Your login does not allow campaign activation."
            return false;
        }

        var noEndDates = $scope.campaign.AvailableEndDates.length === 0;
        var hasValidEndDate = !noEndDates;

        var canHaveNoCustomers = !$scope.hasVouchers($scope.campaign) && !$scope.hasCommunications($scope.campaign);
        var hasCustomers = canHaveNoCustomers || $scope.campaign.SelectedCustomerCount > 0;

        return hasValidEndDate && (hasCustomers || canHaveNoCustomers);
    };

    $scope.userHasPermissionToActivateCampaign = function() {
        return PermissionService.doesUserHavePermission(Dashboard.Models.Lookups.Permissions.ActivateCampaigns);
    };

    /**
     * Shows the modal campaign successfully published modal
     */
    self.showCampaignPublishedSuccessModal = function (launchDate) {
        // Show the context picker modal
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'components/campaigns/managecampaign/modals/campaignpublishedsuccessmodal.137d083a.html',
            controller: 'CampaignPublishedSuccessModalController',
            size: 'lg',
            backdrop: 'static',
            resolve: {
                launchDate: function () {
                    return launchDate
                }
            }
        });

        modalInstance.result.then(function () {
            // Navigate to the active campaigns for the current context
            $state.go(Dashboard.helpers.stateHelper.getParentState($state.current.name) + '.currentcampaigns', {brandId: self.userContext.BrandId, storeId: self.userContext.StoreId });
        });
    };

    self.initialise();
}

angular
    .module('dashboard')
    .component('campaignWizardSummary',
        {
            templateUrl: 'components/campaigns/wizard/step-3/campaign-wizard-summary.6e1a0e85.html',
            bindings: {
            },
            controller: [
                '$scope',
                '$injector',
                '$timeout',
                '$uibModal',
                '$state',
                'LocalisationService',
                'CampaignsService',
                'ErrorService',
                'CampaignWizardService',
                'PermissionService',
                CampaignWizardSummaryController]
        });
